import { FC, useContext, useState } from 'react';
import { QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";
import { QESRadioButton } from "@app/shared/qes-standards";
import { NetworkCoverageMapDataContext } from '../contexts/NetworkCoverageMapDataContext';
import { MapCustomControlProps } from '@app/shared/mapping/MapCustomControlProps';
import { MappingContext } from '@app/mapping/MappingContext';
import { createPortal } from 'react-dom';
import { useMapboxControl } from '@app/shared/mapping/useMapBoxControl';

const NetworkCoverageMapLayerControl: FC<MapCustomControlProps> = ({ignoreInMapExport, imagePath, mapRef, position}) => {

  const mappingContext = useContext(MappingContext);
  const networkCoverageMapDataContext = useContext(NetworkCoverageMapDataContext);

  const [showLayerControl, setShowLayerControl] = useState(false);

  const handleCheckBoxMemberLayerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, checked} = e.target;

    if (name == 'withAccess') {
      networkCoverageMapDataContext.setShowMembersWithAccess(checked);
    } else if (name == 'withoutAccess') {
      networkCoverageMapDataContext.setShowMembersWithoutAccess(checked);
    }
  }

  const container = useMapboxControl({mapRef, position});
  if (!container) return null;

  return createPortal (

    <div className="layer-control-main-container" {...(ignoreInMapExport ? { 'data-html2canvas-ignore': '' } : {})}>

      <div className="layer-hover-container" onClick={() => setShowLayerControl((prev) => !prev)}>
        <img src={imagePath} className="layer-hover-icon" />
      </div>

      {showLayerControl && 
        <div className="layer-control-container">
          {/* Members Section */}
          <span className="provider-member-layer-control__title">Members</span>
          <div className="provider-member-layer-control__layers-container">
            <label className="provider-member-layer-control__label">
              <QESCheckbox
                checked={networkCoverageMapDataContext.showMembersWithAccess}
                onChange={handleCheckBoxMemberLayerChange}
                label="With Access"
                name='withAccess'
                testId="members-with-access-checkbox"
              />
            </label>
            <label className="provider-member-layer-control__label">
              <QESCheckbox
                checked={networkCoverageMapDataContext.showMembersWithoutAccess}
                onChange={handleCheckBoxMemberLayerChange}
                label="Without Access"
                name='withoutAccess'
                testId="members-without-access-checkbox"
              />
            </label>
          </div>

          {/* Map Style Section */}
          <span className="provider-member-layer-control__title">Map Style</span>
          <div className="provider-member-layer-control__layers-container">
            <label className="provider-member-layer-control__label">
              <QESRadioButton
                name="map-style"
                checked={networkCoverageMapDataContext.mapStyle == mappingContext.qesLightStyle}
                onChange={(e) => networkCoverageMapDataContext.setMapStyle(e.target.value)}
                label="Light"
                testId="map-style-light-radio"
                value={mappingContext.qesLightStyle}
              />
            </label>
            <label className="provider-member-layer-control__label">
              <QESRadioButton
                name="map-style"
                checked={networkCoverageMapDataContext.mapStyle == mappingContext.qesOutdoorsStyle}
                onChange={(e) => networkCoverageMapDataContext.setMapStyle(e.target.value)}
                label="Terrain"
                testId="map-style-terrain-radio"
                value={mappingContext.qesOutdoorsStyle}
              />
            </label>
          </div>
        </div>
      }
    </div>, 
    container
    )
};

export default NetworkCoverageMapLayerControl;
